// extracted by mini-css-extract-plugin
export default {"btn":"HomeButtons_btn__55lNl","btn_validate":"HomeButtons_btn_validate__3XFLb","btn_clean":"HomeButtons_btn_clean__PV5yi"};